export default __webpack_public_path__ + "static/media/information-circle.ce63870e.svg";